import { WebService } from '../api/web.service'
import { Store } from '@ngrx/store'
import { AppState } from '../../store/state/app.state'
import { Injectable } from '@angular/core'
import { ServiceUrlConstants } from '../../constants/service-url-constants'
import {
  fetch_employee_personal_info,
  fetch_employee_with_reference_details,
  update_employee_personal_info_action
} from '../../store/action/employee.action'
import { EmployeeAPIModel } from '../../models/api.model'
import { map } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private webService: WebService, private appState: Store<AppState>) {}

  dispatchGetEmployeePersonalInfoData() {
    this.appState.dispatch(fetch_employee_personal_info())
  }
  getEmployeePersonalInfoData() {
    return this.webService.get(ServiceUrlConstants.API_EMPLOYEE_PERSONAL_INFO)
  }

  dispatchUpdateEmployeePersonalInfoAction(employee: EmployeeAPIModel) {
    this.appState.dispatch(update_employee_personal_info_action(employee))
  }

  callUpdateApi = (employee: EmployeeAPIModel) => {
    const endPoint = ServiceUrlConstants.API_EMPLOYEE_PERSONAL_INFO
    return this.webService.put(endPoint, employee).pipe(map((employee: EmployeeAPIModel) => employee))
  }

  dispatchGetEmployeeWithReferenceDetails() {
    this.appState.dispatch(fetch_employee_with_reference_details())
  }

  getEmployeeWithReferenceDetails() {
    return this.webService.get(ServiceUrlConstants.API_EMPLOYEE_REFERENCE_DETAILS)
  }
}
